import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { Observable } from "rxjs";
import { Router } from "../service/router/router";
import { AuthStore } from "../store/auth.store";

@Injectable({
	providedIn: "root",
})
export class AuthGuard implements CanActivate {
	constructor(
		private readonly authStore: AuthStore,
		private readonly router: Router,
	) {}

	canActivate(): Observable<boolean> | Promise<boolean> | boolean {
		const user = this.authStore.me();
		if (!user) {
			this.router.navigate(["/auth"]);
			return false;
		}
		return true;
	}
}
